import { useEffect } from "react";
import { useEditItem2 } from "../../../api/useNewItem";
import { useCMSSettingsContext } from "./CMSSettingsContext";

export const CustomFieldsBlockConfigurationSettingKey = "custom_fields_block_settings";
export const ConfigurableTableBlockConfigurationSettingKey = "configurable_table_block_settings";

const ExampleConfiguration = {
  example: { fields: ["title; Title; text", "options; Options; select; 1,2,3,4"] },
}

interface BlocksSettingsEdit {
  custom_fields_block_config: string;
  configurable_table_block_config: string;
}

export const useEditBlocksConfiguration = () => {
  const settingsCtx = useCMSSettingsContext();

  useEffect(() => {
    settingsCtx.ensureLoaded();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editBlocksSettings = useEditItem2<BlocksSettingsEdit>({
    save: async (item, changes) => {
      try {
        const changesX: any = {};
        if(changes.custom_fields_block_config) {
          changesX[CustomFieldsBlockConfigurationSettingKey] = JSON.parse(changes.custom_fields_block_config);
        }
        if(changes.configurable_table_block_config) {
          changesX[ConfigurableTableBlockConfigurationSettingKey] = JSON.parse(changes.configurable_table_block_config);
        }
        settingsCtx.updateSettings(changesX);
      } catch(e) {
      }
      return item;
    }
  });

  const start = () => {
    editBlocksSettings.startEditing({
      custom_fields_block_config: JSON.stringify(settingsCtx.settings[CustomFieldsBlockConfigurationSettingKey] || ExampleConfiguration, null, 2),
      configurable_table_block_config: JSON.stringify(settingsCtx.settings[ConfigurableTableBlockConfigurationSettingKey] || ExampleConfiguration, null, 2),
    })
  }

  return {
    ...editBlocksSettings,
    start,
  }
}


export type BlocksConfigurationData = ReturnType<typeof useEditBlocksConfiguration>;
